export default __webpack_public_path__ + "static/media/kalahastiHistoryTwo.ff16bc1a.jpg";